import DialogHelper from 'helpers/dialog';
import { setGlobalSuccessMsg } from 'store/global/globalActions';

const saveEmailAlertSettings = (dispatch, reportName, modal, setModal, updateSingleReportSettings) => {
  const _emails = modal.cc_emails.trim();
  const data = {
    name: reportName,
    settings: {
      'cc_emails': _emails ? _emails.split(',').map(e => e.trim()) : [],
    },
  }
  setModal({ ...modal, loading: true });
  dispatch(updateSingleReportSettings(data))
    .then(() => {
      dispatch(setGlobalSuccessMsg({ model: 'Report settings', action: 'updated' }));
      setModal(false);
    })
    .catch(() => setModal({ ...modal, loading: false }));
}

const extraEmailsModal = (modal, setModal, onConfirm) => modal && modal.name === 'alerts' && DialogHelper.inputs({
  title: 'Email Alerts',
  iconColor: 'primary',
  btnColor: 'success',
  btnText: 'Save',
  header: 'Add additional email addresses to receive alerts for this report and keep recipients informed.',
  loading: modal.loading,
  onConfirm,
  onClose: () => setModal(false),
  inputs: [{
      name: 'cc_emails',
      type: 'text',
      label: 'CC Email Addresses (comma-separated)',
      value: modal.cc_emails,
      onChange: (e) => setModal({ ...modal, cc_emails: e.target.value }),
      placeholder: 'e.g. jane@example.com, john@example.com',
    }],
})

const ReportTraits = {
  saveEmailAlertSettings,
  extraEmailsModal,
}

export default ReportTraits;